import styled from 'styled-components';

import { SpaceBetweenBlock } from '../../../styled';

export const UsersHeaderWrapper = styled(SpaceBetweenBlock)`
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid ${(props) => props.theme.colors.stroke};
`;

export const BoldWrapper = styled.b`
  color: ${(p) => p.theme.colors.text};
`;
